export enum BarTone {
  TargetMet = 'targetMet',
  TargetInProgress = 'targetInProgress',
  NoThreshold = 'noThreshold',
  ArchivedPlan = 'archivedPlan',
}

interface IBarToneParams {
  threshold: number | null;
  isTargetMet: boolean;
}

const getBarTone = ({ threshold, isTargetMet }: IBarToneParams): BarTone => {
  if (threshold === null) return BarTone.NoThreshold;
  return isTargetMet ? BarTone.TargetMet : BarTone.TargetInProgress;
};

export default getBarTone;
